const config = {
  API_BASE_URL: process.env.REACT_APP_API_URL || 'https://blogcraft.shop/backend/api',
  SITE_NAME: 'BlogCraft',
  SITE_DESCRIPTION: 'Your source for quality content on technology, lifestyle, business, and more',
  SITE_URL: process.env.REACT_APP_SITE_URL || 'https://blogcraft.shop',
  POSTS_PER_PAGE: 12,
};

export default config;
